import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { api } from '../utils/api';

export default function RedefinirSenha() {
  const { token } = useParams();
  const [nome, setNome] = useState('');
  const [senha, setSenha] = useState('');
  const [confirmar, setConfirmar] = useState('');
  const [mostrar, setMostrar] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [erro, setErro] = useState('');
  const [valido, setValido] = useState(false);
  const [concluido, setConcluido] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    api.get(`/senha/validar/${token}`)
      .then(d => { setNome(d.nome); setValido(true); })
      .catch(e => setErro(e.message))
      .finally(() => setLoading(false));
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (senha !== confirmar) return setErro('As senhas não coincidem');
    if (senha.length < 6) return setErro('A senha deve ter ao menos 6 caracteres');
    setSaving(true); setErro('');
    try {
      await api.post(`/senha/redefinir/${token}`, { senha });
      setConcluido(true);
    } catch (err) { setErro(err.message); }
    finally { setSaving(false); }
  };

  if (loading) return <div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100vh',color:'#6B7289'}}>Verificando link...</div>;

  return (
    <div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100vh',background:'#F4F5F9'}}>
      <div style={{background:'#fff',borderRadius:20,padding:48,width:420,boxShadow:'0 4px 32px rgba(0,0,0,.08)'}}>
        <div style={{fontSize:12,fontWeight:600,color:'#1A2ECC',textTransform:'uppercase',letterSpacing:'.1em',marginBottom:12}}>Cockpit do Importador</div>
        <h2 style={{fontSize:22,fontWeight:700,letterSpacing:'-.02em',marginBottom:6}}>Criar nova senha</h2>

        {concluido ? (
          <>
            <div style={{background:'#E6F7F1',border:'0.5px solid #B8E6D2',borderRadius:10,padding:16,fontSize:13,color:'#0A6B47',margin:'16px 0 20px'}}>
              ✅ Senha alterada com sucesso. Entre com a nova senha.
            </div>
            <button className="btn-primary" style={{width:'100%',padding:13}} onClick={()=>navigate('/login')}>Ir para o login →</button>
          </>
        ) : !valido ? (
          <>
            <div style={{background:'#FDEAEA',borderRadius:10,padding:16,fontSize:13,color:'#922020',margin:'16px 0 20px'}}>{erro || 'Link inválido ou expirado.'}</div>
            <button className="btn-primary" style={{width:'100%',padding:13}} onClick={()=>navigate('/login')}>Voltar para o login</button>
          </>
        ) : (
          <>
            <p style={{fontSize:13,color:'#6B7289',marginBottom:24}}>Olá, {nome}! Escolha uma nova senha para acessar o cockpit.</p>
            <form onSubmit={handleSubmit}>
              <div style={{marginBottom:12}}>
                <label style={{fontSize:12,fontWeight:500,color:'#6B7289',display:'block',marginBottom:5}}>Nova senha</label>
                <div style={{position:'relative'}}>
                  <input className="input-field" type={mostrar ? 'text' : 'password'} placeholder="Mínimo 6 caracteres" value={senha} onChange={e=>setSenha(e.target.value)} required style={{paddingRight:44}} />
                  <button type="button" onClick={()=>setMostrar(!mostrar)}
                    style={{position:'absolute',right:12,top:'50%',transform:'translateY(-50%)',background:'none',border:'none',cursor:'pointer',color:'#9095A8',fontSize:12}}>
                    {mostrar ? 'Ocultar' : 'Ver'}
                  </button>
                </div>
              </div>
              <div style={{marginBottom:20}}>
                <label style={{fontSize:12,fontWeight:500,color:'#6B7289',display:'block',marginBottom:5}}>Confirmar nova senha</label>
                <input className="input-field" type={mostrar ? 'text' : 'password'} placeholder="Repita a senha" value={confirmar} onChange={e=>setConfirmar(e.target.value)} required />
              </div>
              {erro && <div style={{background:'#FDEAEA',borderRadius:8,padding:'10px 14px',fontSize:12,color:'#922020',marginBottom:14}}>{erro}</div>}
              <button className="btn-primary" type="submit" disabled={saving} style={{width:'100%',padding:13}}>
                {saving ? 'Salvando...' : 'Salvar nova senha →'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
